import React from "react";
import colors from "@/components/styles/colors";
export function getContactHighlight(keyword: string): React.ReactNode | string {
  if (!keyword) {
    return "";
  }
  return (
    <>
      <span>尝试搜索更多关于“</span>
      <span style={{ color: `${colors.primary2}`, wordBreak: "break-all" }}>{keyword}</span>
      <span>”的用户</span>
    </>
  );
}

export function getHighlightComp(
  highlight: {
    key: string;
    name: string;
    value: string;
    tip?: string;
  }[],
  name: string,
  defualtStrValue?: string
): React.ReactNode | string {
  if (!highlight.length) {
    return defualtStrValue || "";
  }
  const hl = highlight.find((item) => item.name === name);
  if (!hl) {
    return defualtStrValue || "";
  }

  const comps: any[] = [];
  let idx = 0;
  const { key, value, tip = "" } = hl;
  const index = key.indexOf(",");
  // @ts-ignore
  value?.replace(new RegExp(key, "g"), (a: any, i: any) => {
    comps.push(<span key={i}>{value?.slice(idx, i)}</span>);
    comps.push(
      <span key={`${i}-1`} className="color-primary">
        {value?.slice(i, i + key.length)}
      </span>
    );
    idx = i + key.length;
  });
  if (index > -1) {
    const newKey = key.split(",")[0];
    // @ts-ignore
    value?.replace(new RegExp(newKey, "ig"), (a: any, i: any) => {
      comps.push(<span key={i}>{value?.slice(idx, i)}</span>);
      comps.push(
        <span key={`${i}-1`} className="color-primary">
          {value?.slice(i, i + newKey.length)}
        </span>
      );
      idx = i + newKey.length;
    });
  }

  comps.push(<span key={`${idx}-last`}>{value?.slice(idx)}</span>);
  return (
    <div
      style={{
        display: "inline-block",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        width: "100%"
      }}
    >
      {comps}
      {tip && <span style={{ opacity: 0.5 }}>{tip}</span>}
    </div>
  );
}

export function getTelHighlightComp(telHighlight: any) {
  if (!telHighlight) {
    return "";
  }
  return <>座机号：{getHighlightComp([telHighlight], "titleList.telephone")}</>;
}

export function getHighlightCompWithLabel(label: string, highlight: any, key: string) {
  if (!highlight) {
    return "";
  }
  return (
    <div
      style={{
        display: "flex",
        direction: "ltr",
        alignItems: "center"
      }}
    >
      {label}：{getHighlightComp([highlight], key)}
    </div>
  );
}
